export default __webpack_public_path__ + "images/a3f645463e3bd6dfa62c669c04f97188-hockey.jpg";